import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../components/AppShell/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 32px;

  @media not all and (min-width: ${DESKTOP_BREAKPOINT}) {
    padding: 0 20px;
  }

  > .image {
    padding: 32px;

    @media (max-width: 320px) {
      padding: 0.5rem;
    }
  }

  > .text {
    text-align: center;
    h3 {
      margin-bottom: 16px;
    }
  }

  > .cta {
    margin-top: 1.5rem;
  }
`;
